export default "__VITE_ASSET__CKcDNixT__"